/* eslint-disable react/prop-types */
import { Plus } from 'lucide-react';
import React, { useState } from 'react';
import styles from './ButtonAdd.module.css';

function ButtonAdd2({
  text = 'Button2',
  onClick = () => {},
  disabled = false,
  Icon = Plus,
  height = '35px',
  padding = '17px',
  className = '',
}) {
  const [isLoading, setIsLoading] = useState(false);
  return (

    <button
      type="button"
      className={`${disabled ? '' : styles.buttonAdd} ${className}`}
      disabled={disabled}
      style={{
        height,
        borderRadius: '17px',
        border: disabled || isLoading ? '1px solid var(--main1Border)' : '1px solid transparent',
        background: disabled || isLoading ? 'none' : 'var(--special-color)',
        color: disabled || isLoading ? 'grey' : 'white',
        cursor: disabled || isLoading ? 'not-allowed' : 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding,
        fontSize: '14px',
        fontWeight: 600,
        gap: className ? '0px' : '5px',
      }}
      onClick={async () => {
        setIsLoading(() => true);
        await onClick();
        setIsLoading(() => false);
      }}
    >
      {text}
      <Icon
        className={styles.add}
        style={{ color: disabled || isLoading ? 'grey' : 'white' }}
        size={20}
      />
    </button>
  );
}
export default ButtonAdd2;
